import type { SearchFilterType } from '@/scopes/search/search/infrastructure/api/types'

export const DEFAULT_RESULTS_PER_PAGE = 10

export const COMPULSORY_FILTER_TYPES: SearchFilterType[] = ['TransportType', 'Participants', 'Duration']

export const SEARCH_ELEMENT = 'search-element'
export const SEARCH_ELEMENT_ID = `#${SEARCH_ELEMENT}`
